const WORKSPACE_COOKIE_NAME = 'amp_recent_workspaces';
const MAX_REMEMBERED_WORKSPACES = 5;
const COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 90;

interface RememberedWorkspace {
  email: string;
  workspace: string;
}

const readRememberedWorkspaces = (): RememberedWorkspace[] => {
  const cookie = document.cookie.split('; ').find((c) => c.startsWith(`${WORKSPACE_COOKIE_NAME}=`));
  if (!cookie) {
    return [];
  }
  try {
    return JSON.parse(decodeURIComponent(cookie.substring(cookie.indexOf('=') + 1))) as RememberedWorkspace[];
  } catch {
    return [];
  }
};

const writeRememberedWorkspaces = (workspaces: RememberedWorkspace[]): void => {
  /* istanbul ignore next — tests always run on http, so the https branch is never exercised */
  const secure = document.location.protocol === 'https:' ? '; secure' : '';
  document.cookie = `${WORKSPACE_COOKIE_NAME}=${encodeURIComponent(
    JSON.stringify(workspaces)
  )}; path=/; max-age=${COOKIE_MAX_AGE_SECONDS}; samesite=lax${secure}`;
};

// Records the workspace as the most recently used one for this email, so the workspace
// selection page can offer a quick "continue with workspace" option on a later visit.
export const rememberWorkspace = ({ email, workspace }: { email: string; workspace: string }): void => {
  const others = readRememberedWorkspaces().filter((entry) => entry.email !== email);
  writeRememberedWorkspaces([{ email, workspace }, ...others].slice(0, MAX_REMEMBERED_WORKSPACES));
};

export const getRememberedWorkspace = (email: string): string | null => {
  return readRememberedWorkspaces().find((entry) => entry.email === email)?.workspace ?? null;
};

export const forgetWorkspace = (email: string): void => {
  writeRememberedWorkspaces(readRememberedWorkspaces().filter((entry) => entry.email !== email));
};
